import React from 'react';
import PropTypes from 'prop-types';

/**
 * Wrapper
 *  - Wrapper component for Scroll Icons
 */
export function Wrapper(props) {
  return <div className='controlsWrapper'>{props.children}</div>;
}

Wrapper.propTypes = {
  /**
   * Component to be dispalyed in side Controls/Wrapper
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};
